// extracted by mini-css-extract-plugin
export default {"layout":"w8GHd","container":"mTSZ5","inner":"j3oao","main":"Y7QNK"};